import { ArticleBlockText } from "../../../site/content-types/article-new/article-new.d";

import React from 'react';

// TODO: Use RichText from @enonic/react-components
//       Requires all Macros to be reimplemented in React.
import RichText from "../../../react4xp/shared/Richtext/Richtext";
// import { RichText } from '@enonic/react-components';


export function TextBlock({ title, body }: ArticleBlockText): React.JSX.Element {
	return (
		<div className="article article__rich-text-container">
			{title && <h2>{title}</h2>}
			<RichText className="rich-text" text={body}/>
		</div>
	);
}
